import { mailingCommunicationStore } from '@/services/MailingCommunications/store'

import { notifyError, notifyMessage, notifyProblem } from '@/services/notify'

export const methods = {
  async reload() {
    this.communicationID = this.$route.params.id

    if (this.isDebug == true) console.debug('attachments communicationID=' + this.communicationID)

    if (this.communicationID !== undefined && this.communicationID > 0) {
      //Load any existing attachments
      await this.getAttachments()
    }
  },

  async deleteConfirmation() {
    this.$buefy.dialog.confirm({
      title: 'Delete Attachments',
      message: `Are you sure you want to <b>Delete your Attachments</b>?`,
      confirmText: 'Delete Attachments',
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => await this.deleteAttachments()
    })
  },

  async deleteDropFile(index) {
    this.files.splice(index, 1)
    this.previews.splice(index, 1)
  },

  async deleteAttachments() {
    if (this.hasReadonly === false) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      })

      if (this.communicationAttachments && (this.mailingCommunicationID || this.communicationID)) {
        try {
          await mailingCommunicationStore.dispatch('deleteCommunicationAttachmentsByParentId', {
            communicationID: this.mailingCommunicationID
              ? this.mailingCommunicationID
              : this.communicationID,
            done: async () => {
              notifyMessage(`Successfully deleted the attachments.`)
              if (this.documents) this.documents.splice(0, this.documents.length)
              if (this.communicationAttachments)
                this.communicationAttachments.splice(0, this.communicationAttachments.length)
              if (this.files) this.files.splice(0, this.files.length)
              if (this.previews) this.previews.splice(0, this.previews.length)
            }
          })
        } catch (e) {
          notifyError(e)
        }
      }

      this.$store.dispatch('communication/saveIsEdit', {
        isEdit: true
      })

      setTimeout(() => loadingComponent.close(), 1000)
    }
  },

  async updateAttachments() {
    if (this.hasReadonly === false) {
      console.debug('in updatedAttachments...')
      const attachments = this.files
      if (!Array.isArray(attachments)) {
        notifyProblem('A problem occurred and the attachments could not be uploaded.')
        return
      }

      ////////////////////////////////
      //  Store previews
      ////////////////////////////////

      this.previews = this.files.map(file => {
        return URL.createObjectURL(file)
      })

      console.debug('in updateAttachments...' + this.files.length)

      //this.$store.dispatch('conversation/modify', {
      //  previews: this.previews,
      //  attachments
      //})
    }
  },

  async saveAttachments() {
    if (this.hasReadonly === false) {
      const id = this.mailingCommunicationID ? this.mailingCommunicationID : this.communicationID

      if (!this.files || this.files.length === 0) {
        notifyProblem(`Please select a file to upload. There are no files selected.`)
      }

      console.debug('in saveAttachments id=' + id)
      //Process one or more attachments

      const loadingComponent = this.$buefy.loading.open({
        container: null
      })

      try {
        if (this.isDebug === true) console.debug('files=' + this.files)

        if (
          this.files &&
          this.files.length > 0 &&
          (this.mailingCommunicationID || this.communicationID)
        ) {
          for (let a = 0; a < this.files.length; a++) {
            try {
              const file = this.files[a]
              console.debug('file=' + file)

              if (file !== undefined && file) {
                const payload = {
                  communicationID: this.mailingCommunicationID
                    ? this.mailingCommunicationID
                    : this.communicationID,
                  cursorPosition: this.cursorLocation,
                  supportsMail: false,
                  supportsEmail: true,
                  description: this.communicationDescription,
                  isAttachment: true
                }

                console.debug('payload addConversationAttachment=' + JSON.stringify(payload))

                await mailingCommunicationStore.dispatch('addCommunicationAttachment', {
                  payload,
                  done: async ({ detail }) => {
                    if (detail) {
                      console.debug('addCommunicationAttachment=' + JSON.stringify(detail))

                      const payload = {
                        communicationAttachmentID: detail.communicationAttachmentID,
                        file: file
                      }

                      this.$store.dispatch('communication/saveIsEdit', {
                        isEdit: true
                      })

                      await mailingCommunicationStore
                        .dispatch('uploadCommunicationAttachmentDocument', {
                          payload: payload
                        })
                        .then(async returnedfile => {
                          if (returnedfile && detail) {
                            console.debug('returnedfile=' + JSON.stringify(returnedfile))
                          }
                        })
                    }
                  }
                })
              }
            } catch (e) {
              setTimeout(() => loadingComponent.close(), 1000)
              notifyError(e)
            }
          }

          notifyMessage(`Successfully added your selected attachment(s).`)
        }
      } catch (e) {
        setTimeout(() => loadingComponent.close(), 1000)
        notifyError(e)
      }

      setTimeout(async () => await this.getAttachments(), 3000)

      setTimeout(() => loadingComponent.close(), 1000)
    }
  },

  async openPDFModal(id) {
    if (this.documents) {
      for (let a = 0; a < this.documents.length; a++) {
        const document = this.documents[a]
        if (this.isDebug === true)
          console.debug('document id=' + id + ', document id=' + document.id)

        if (document.id === id) {
          this.$refs.pdfModal.open({
            src: this.documents[a].content
          })
          return
        }
      }
    }
  },

  async getAttachments() {
    if (this.files) this.files.splice(0, this.files.length)
    if (this.documents) this.documents.splice(0, this.documents.length)
    if (
      this.communicationAttachments !== undefined &&
      this.communicationAttachments &&
      this.communicationAttachments.length > 0
    )
      this.communicationAttachments.splice(0, this.communicationAttachments.length)

    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    console.debug('in getAttachments...')
    //Need communications attachments list
    if (this.mailingCommunicationID > 0 || this.communicationID) {
      console.debug('in getAttachments if...')
      await mailingCommunicationStore
        .dispatch('getCommunicationAttachmentsByParentId', {
          communicationID: this.mailingCommunicationID
            ? this.mailingCommunicationID
            : this.communicationID
        })
        .then(({ list }) => {
          console.debug('in getAttachments before list')
          if (list) {
            console.debug('in getAttachments list')
            this.communicationAttachments = list

            Array.from(list).forEach(ca => {
              console.debug('in ca=' + JSON.stringify(ca))
              try {
                console.debug('image or pdf............' + JSON.stringify(ca))

                //documents
                this.documents.push({
                  content: ca.baseString,
                  id: ca.communicationAttachmentID
                })
              } catch (e) {
                console.debug(e)
              }
            })
          }
        })
    }

    setTimeout(() => loadingComponent.close(), 1000)
  },

  async handleImageRemoved(file) {
    if (this.hasReadonly === false) {
      console.debug('in handleImageRemoved...')
      const loadingComponent = this.$buefy.loading.open({
        container: null
      })

      const flatContents = JSON.stringify(file)
      const flatContentsSplit = flatContents.split('communicationAttachmentID=')
      const communicationAttachmentID = parseInt(
        flatContentsSplit[1] !== undefined && flatContentsSplit[1] ? flatContentsSplit[1] : 0
      )

      console.debug('communicationAttachmentID=' + communicationAttachmentID)

      if (communicationAttachmentID > 0) {
        try {
          await mailingCommunicationStore.dispatch('deleteCommunicationAttachment', {
            communicationAttachmentID,
            done: () => {}
          })
        } catch (e) {
          loadingComponent.close()
          console.debug('There was an issue deleting this communication attachment.' + e)
        }
      }

      this.$store.dispatch('communication/saveIsEdit', {
        isEdit: true
      })

      loadingComponent.close()
    }
  }
}
